import React, { useState, useEffect } from "react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useParams, useNavigate } from "react-router-dom";
import Constants from "../../utils/Constants";
import SplashScreen from "../../components/loader/SplashScreen/SplashScreen";
import { View, ChevronLeft } from "@carbon/icons-react";
import ReactPaginate from "react-paginate";
import CampaignRecipientResponseDetail from "./CampaignRecipientResponseDetail";

const CampaignRecepientList = () => {
  const { id: campaignId } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [showDetail, setShowDetail] = useState(false);

  const ResponsesApi = (page) => {
    return axios({
      method: "get",
      params: {
        page: page || 1,
        limit: 100,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      url: `${Constants.url}survey-campaigns/${campaignId}/recipients`,
    }).then((res) => {
      // console.log("data: ", res.data);
      return res.data;
    });
  };

  const {
    data: ResponsesData,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["campaign-responses", campaignId, page],
    queryFn: () => ResponsesApi(page),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!campaignId,
  });

  useEffect(() => {
    if (campaignId) {
      refetch();
    }
  }, [campaignId, refetch]);

  const recipients = ResponsesData?.data?.recipients || [];
  const summary = ResponsesData?.summary || {};
  const pagination = ResponsesData?.pagination || {};
  const responses = recipients;

  const handleViewResponse = (response) => {
    setSelectedResponse(response);
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setSelectedResponse(null);
  };

  if (showDetail && selectedResponse) {
    return (
      <CampaignRecipientResponseDetail
        response={selectedResponse}
        onBack={handleCloseDetail}
      />
    );
  }

  return (
    <>
      {isLoading ? (
        <div className="dashboardWrp uk-padding" style={{ textAlign: "center", padding: "40px" }}>
          <p>Loading...</p>
        </div>
      ) : !loader ? (
        <div className="dashboardWrp" style={{ padding: "2rem" }}>
          <div className="uk-container uk-container-expand">
            <div className="uk-margin-medium-bottom">
              <button
                className="uk-button uk-button-secondary back-btn"
                onClick={() => navigate("/survey-campaigns")}
              >
                <ChevronLeft size={24} />
                Back to Campaigns
              </button>
            </div>

            <div className="uk-margin">
              <div className="uk-flex uk-flex-between">
                <div>
                  <h2>Campaign Recepients List</h2>
                </div>
              </div>
            </div>

            <div className="uk-margin-medium-top uk-margin-medium-bottom">
              <div className="uk-grid uk-grid-small uk-grid-match" uk-grid="true">
                <div className="uk-width-1-3@m uk-width-1-2@s uk-width-1-1">
                  <div className="uk-card uk-card-default uk-card-body">
                    <h3 className="uk-card-title" style={{fontSize: '0.875rem', marginBottom: '0.75rem', color: '#666'}}>Total Sent</h3>
                    <p style={{fontSize: '2rem', fontWeight: '700', margin: 0, color: '#161616'}}>{summary?.totalSent || 0}</p>
                  </div>
                </div>
                <div className="uk-width-1-3@m uk-width-1-2@s uk-width-1-1">
                  <div className="uk-card uk-card-default uk-card-body">
                    <h3 className="uk-card-title" style={{fontSize: '0.875rem', marginBottom: '0.75rem', color: '#666'}}>Completed</h3>
                    <p style={{fontSize: '2rem', fontWeight: '700', margin: 0, color: '#28a745'}}>{summary?.completed || 0}</p>
                  </div>
                </div>
                <div className="uk-width-1-3@m uk-width-1-2@s uk-width-1-1">
                  <div className="uk-card uk-card-default uk-card-body">
                    <h3 className="uk-card-title" style={{fontSize: '0.875rem', marginBottom: '0.75rem', color: '#666'}}>Accessed</h3>
                    <p style={{fontSize: '2rem', fontWeight: '700', margin: 0, color: '#0f62fe'}}>{summary?.accessed || 0}</p>
                  </div>
                </div>
                <div className="uk-width-1-3@m uk-width-1-2@s uk-width-1-1">
                  <div className="uk-card uk-card-default uk-card-body">
                    <h3 className="uk-card-title" style={{fontSize: '0.875rem', marginBottom: '0.75rem', color: '#666'}}>In Progress</h3>
                    <p style={{fontSize: '2rem', fontWeight: '700', margin: 0, color: '#ffc107'}}>{summary?.inProgress || 0}</p>
                  </div>
                </div>
                <div className="uk-width-1-3@m uk-width-1-2@s uk-width-1-1">
                  <div className="uk-card uk-card-default uk-card-body">
                    <h3 className="uk-card-title" style={{fontSize: '0.875rem', marginBottom: '0.75rem', color: '#666'}}>Pending</h3>
                    <p style={{fontSize: '2rem', fontWeight: '700', margin: 0, color: '#fd7e14'}}>{summary?.pending || 0}</p>
                  </div>
                </div>
                <div className="uk-width-1-3@m uk-width-1-2@s uk-width-1-1">
                  <div className="uk-card uk-card-default uk-card-body">
                    <h3 className="uk-card-title" style={{fontSize: '0.875rem', marginBottom: '0.75rem', color: '#666'}}>Expired</h3>
                    <p style={{fontSize: '2rem', fontWeight: '700', margin: 0, color: '#dc3545'}}>{summary?.expired || 0}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="analyticsTableWrp uk-overflow-auto">
              <table className="uk-table uk-table-striped">
                <thead className="table-header-shadow">
                  <tr>
                    <th>S.No</th>
                    <th>Customer</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Order No</th>
                    <th>Status</th>
                    <th>Submitted At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {responses.length > 0 ? (
                    responses.map((response, index) => (
                      <tr key={response.id}>
                        <td>{index + 1}</td>
                        <td>
                          {response.customer?.name || 
                           `${response.customer?.email?.split('@')[0] || 'Customer'}`}
                        </td>
                        <td>{response.customer?.email || 'N/A'}</td>
                        <td>{response.customer?.phone || 'N/A'}</td>
                        <td>{response.order?.orderNo || 'N/A'}</td>
                        <td>
                          <span style={{
                            display: 'inline-block',
                            padding: '4px 12px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: '600',
                            backgroundColor: response.status === 'completed' ? '#28a745' : response.status === 'pending' ? '#ffc107' : '#6c757d',
                            color: response.status === 'pending' ? '#000' : '#fff'
                          }}>
                            {response.status?.charAt(0).toUpperCase() + response.status?.slice(1) || 'N/A'}
                          </span>
                        </td>
                        <td>
                          {response.response?.submittedAt
                            ? new Date(response.response.submittedAt).toLocaleString(
                                "en-US",
                                {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )
                            : "-"}
                        </td>
                        <td>
                          {response.isCompleted ? (
                            <button
                              className="uk-button uk-button-text"
                              onClick={() => handleViewResponse(response)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                color: "#0f62fe",
                                padding: "0",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              <View size={18} />
                              View
                            </button>
                          ) : (
                            <span style={{ color: "#8a8a8a" }}>Not available</span>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="uk-text-center">
                        No recipients found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {responses?.length === 0 && (
                <div className="uk-padding uk-text-center">
                  <p style={{ color: "#999", fontSize: "14px" }}>
                    No responses found for this campaign
                  </p>
                </div>
              )}
              <div className="paginationcard uk-card uk-card-default uk-margin-remove-top">
                <ReactPaginate
                  previousLabel={"←"}
                  nextLabel={"→"}
                  breakLabel={"..."}
                  pageCount={pagination?.totalPages || 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => setPage(e.selected + 1)}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  forcePage={page - 1}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        // <SplashScreen />
        <>
        
        </>
      )}
    </>
  );
};

export default CampaignRecepientList;
